import React from 'react';
import { useTranslation } from '../../utils/translations';
import AgentRegisterForm from '../AgentRegisterForm/AgentRegisterForm';
import '../PropertyFormModal/PropertyFormModal.css';
import './AgentRegisterModal.css';

const AgentRegisterModal = ({ isOpen, onClose, onSuccess }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content agent-register-modal" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <h2>{t('admin.register.title') || 'Add New Agent'}</h2>
          <button type="button" className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="agent-register-modal-body">
          <AgentRegisterForm
            onSuccess={onSuccess}
            onCancel={onClose}
            showFooter={false}
            showHeader={false}
          />
        </div>
      </div>
    </div>
  );
};

export default AgentRegisterModal;
